import { createReducer } from './index';
import { fromJS } from 'immutable';
import * as ActionTypes from '../actions/types';
import _ from 'lodash';

const INITIAL_STATE = fromJS({
  scoreRecord: fromJS({}),
  posting: false,
  fetching: false,
  message: '',
  patching: false,
  postingFile: false,
  uploadModalOpen: false,
  postingFileMessage: '',
  postingFileInvalidScores: [],
  deleting: false,
  deleteScoreRecordMessage: ''
});

function createScoreRecord(state, action) {
  return state
    .set('posting', true)
}

function createScoreRecordSuccess(state, action) {
  return state
    .set('posting', false)
    .set('message', 'Score record was created successfully')
}

function createScoreRecordFailed(state, action) {
  let msg = '';
  try {
    msg = action.payload.response.body.error.message
  } catch (e) {
    msg = 'Failed to create score record'
  }
  return state
    .set('posting', false)
    .set('message', msg)

}

function resetState(state, action) {
  return INITIAL_STATE;
}

function getScoreRecordById(state, action) {
  return state
    .set('fetching', true)
}

function getScoreRecordByIdSuccess(state, action) {
  return state
    .set('fetching', false)
    .set('scoreRecord', fromJS(action.payload.body))
}

function getScoreRecordByIdFailed(state, action) {
  return state
    .set('fetching', false)
}

function updateScoreRecord(state, action) {
  return state
    .set('patching', true)
}

function updateScoreRecordSuccess(state, action) {
  return state
    .set('patching', false)
}

function updateScoreRecordFailed(state, action) {
  return state
    .set('patching', false)
}

function createScoreRecordFromFile(state, action) {
  return state
    .set('postingFile', true)
    .set('postingFileMessage', '')
}

function createScoreRecordFromFileSuccess(state, action) {
  let invalidScoreMessages = [];
  try {
    invalidScoreMessages = _.reduce(action.payload.body, (acc, current) => {
      if(!current) { return acc }

      return [...acc, ...current.invalidScores.map(item => item.message)]
    }, [])
  } catch (e) {
    invalidScoreMessages = []
  }
  return state
    .set('postingFile', false)
    .set('uploadModalOpen', false)
    .set('postingFileMessage', 'Score submitted from file.')
    .set('postingFileInvalidScores', fromJS(invalidScoreMessages))
}

function createScoreRecordFromFileFailed(state, action) {
  let message = '';
  try {
    message = action.payload.response.body.error.message
  } catch (e) {
    message = 'Failed to create score from file'
  }
  return state
    .set('postingFile', false)
    .set('postingFileMessage', message)
}

function openUploadModal(state, action) {
  return state
    .set('uploadModalOpen', true)
}

function closeUploadModal(state, action) {
  return state
    .set('uploadModalOpen', false)
}

function changeScoreRecordState(state, action) {
  return state
    .set(action.payload.key, fromJS(action.payload.value))
}

function deleteScoreRecord(state, action) {
  return state
    .set('deleting', true)
}

function deleteScoreRecordSuccess(state, action) {
  return state
    .set('deleting', false)
    .set('deleteScoreRecordMessage', 'Score record deleted')
}

function deleteScoreRecordFailed(state, action) {
  return state
    .set('deleting', false)
    .set('deleteScoreRecordMessage', 'Failed to delete score record')
}

function getStoresSuccess(state, action) {
  if(action.payload.body.length === 0){
    return state
      .set('message', 'No stores found for the given combinations.')
  }
  return state
}

export const scoreRecord = createReducer(INITIAL_STATE, {
  [ActionTypes.CREATE_SCORE_RECORD]: createScoreRecord,
  [ActionTypes.CREATE_SCORE_RECORD_SUCCESS]: createScoreRecordSuccess,
  [ActionTypes.CREATE_SCORE_RECORD_FAILED]: createScoreRecordFailed,
  [ActionTypes.GET_SCORE_RECORD_BY_ID]: getScoreRecordById,
  [ActionTypes.GET_SCORE_RECORD_BY_ID_SUCCESS]: getScoreRecordByIdSuccess,
  [ActionTypes.GET_SCORE_RECORD_BY_ID_FAILED]: getScoreRecordByIdFailed,
  [ActionTypes.LOG_OUT]: resetState,
  [ActionTypes.UPDATE_SCORE_RECORD]: updateScoreRecord,
  [ActionTypes.UPDATE_SCORE_RECORD_SUCCESS]: updateScoreRecordSuccess,
  [ActionTypes.UPDATE_SCORE_RECORD_FAILED]: updateScoreRecordFailed,
  [ActionTypes.CREATE_SCORE_RECORD_FROM_FILE]: createScoreRecordFromFile,
  [ActionTypes.CREATE_SCORE_RECORD_FROM_FILE_SUCCESS]: createScoreRecordFromFileSuccess,
  [ActionTypes.CREATE_SCORE_RECORD_FROM_FILE_FAILED]: createScoreRecordFromFileFailed,
  [ActionTypes.OPEN_UPLOAD_MODAL]: openUploadModal,
  [ActionTypes.CLOSE_UPLOAD_MODAL]: closeUploadModal,
  [ActionTypes.CHANGE_SCORE_RECORD_STATE]: changeScoreRecordState,
  [ActionTypes.DELETE_SCORE_RECORD]: deleteScoreRecord,
  [ActionTypes.DELETE_SCORE_RECORD_SUCCESS]: deleteScoreRecordSuccess,
  [ActionTypes.DELETE_SCORE_RECORD_FAILED]: deleteScoreRecordFailed,
  [ActionTypes.GET_STORES_SUCCESS]: getStoresSuccess,
});



// WEBPACK FOOTER //
// ./src/reducers/scoreRecord.js